import { useEffect, useState } from 'react';

const useSeller = (email) => {
    const [isSeller, setIsSeller] = useState(false);
    const [isSellerLoading, SetIsSellerLoading] = useState(true);
    useEffect(() => {
        if(email){
            fetch(`https://bike-mart-server.vercel.app/users/seller/${email}`)
            .then(res => res.json())
            .then(data => {              
                setIsSeller(data.isSeller)
                SetIsSellerLoading(false);
            })
        }
    }, [email])
    
 
    return [isSeller, isSellerLoading]
};

export default useSeller;